import React, { useState, useEffect } from "react";
import Footer from "../../footer";
import AdminSidebar from "../sidebar";
import { getIdData, addData, updateData } from "../../../lib/appcheck"
import {getDataWithTypeForSelect} from '../../../lib/parameters'
import { useNavigate, useParams } from 'react-router-dom';
import DropDown from "../../ui/dropdown";

export default function AppCheckEdit() {

  const [question, setQuestion] = useState();
  const [order, setOrder] = useState(0);
  const [isActive, setIsActive] = useState();
  const [data, setData] = useState([]);
  const [category, setCategory] = useState(null);
  const [defCategory, setDefCategory] = useState(0);
  const [options, setOptions] = useState([]);
  const [catName, setCatName] = useState();

  const navigate = useNavigate();
  let { slug ,cat } = useParams();


  async function GetCategory() {
        //category
        const slct = await  getDataWithTypeForSelect("APPCHECK");
        //console.log("slct",slct);
        setOptions(slct);
        //setCategory(slct[0])
        if (cat != 0)   {
          console.log("cat",cat);
          setCatName(slct.filter(opt => opt.value === parseInt(cat))[0].label) 
        
        }
        //
        console.log("options",slct);
  }


  async function GetData(id) {

    //data
    const questionData = await getIdData(slug);
    console.log("parameterData", questionData[0]);
    setData(questionData);
    setQuestion(questionData[0].question);
    setIsActive(questionData[0].isActive);
    setOrder(questionData[0].order);
    setDefCategory(questionData[0].category);

//isDisabled = {slug === "Add" ? false : true}
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (slug === "Add") {
      console.log("Add" , category.value);
      

      await addData({
        category : category.value,
        question: question,
        isActive: isActive,
        order: order
      });
  
    }
    else {
      console.log("Update");
      await updateData({
        id: slug,
        category:cat,
        question: question,
        isActive: isActive,
        order: order
      });
    }

    navigate("/admin/admin-appcheck");
  };

  useEffect(() => {
    if (slug !== "Add") {
      GetData(slug);
    }
    GetCategory();

  }, [slug])
  return (
            <div className="col-xl-9 col-md-8">
              <div className="settings-widget profile-details">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>{slug === "Add" ? "Add AppCheck" : "Update AppCheck"}</h3>
                  </div>
                  <div className="checkout-form personal-address add-course-info ">
                    <form role="form" onSubmit={handleSubmit}>
                      <div className="row mx-auto">
                      <div className="col-9">
                          <div className="form-group">
                          <label className="form-control-label">
                              Category
                            </label> 

                            {slug === "Add" ? 
                            <DropDown options={options} setCategory = {setCategory} />
                            :
                            <div className="profile-heading">
                              <h5> {catName} </h5>
                            </div>
                             }
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Question
                            </label>
                            <input
                              type="text"
                              value={question}
                              onChange={(e) => setQuestion(e.target.value)}
                              className="form-control"
                              placeholder="Enter Question"
                              required
                            />
                          </div>
                        </div>

                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Order
                            </label>
                            <input
                              type="number"
                              value={order}
                              onChange={(e) => setOrder(e.target.value)}
                              className="form-control"
                              placeholder="Order"
                            />
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Is Active
                            </label>
                            <div className="form-check form-switch check-on">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isActive}
                                onChange={(e) => setIsActive(!isActive)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit" className="btn btn-primary">
                            {slug === "Add" ? "Add AppCheck" : "Update AppCheck"}
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
  );
}
